module.exports = __webpack_public_path__ + "img/IMG_1581.135df361.jpeg";